import React, { Component } from 'react';

import { connect } from 'react-redux';

import OrderDetails from './modules/OrderDetails/templates/OrderDetails';
import UserDetails from './modules/UserDetails/templates/userDetails';
import Message from './components/message/template/Message';
import RestaurantDetails from './modules/RestaurantDetails/templates/restaurantDetails';
import BalanceDetails from './modules/Balance/templates/balanceDetails';
import ReportDetails from './modules/Finance/templates/reportDetails';
import GiftCardDetails from './modules/GiftCard/templates/giftCardDetails';
import PrinterDetails from './modules/Printer/templates/printerDetails';
import TariffDetails from './modules/Salary/templates/TariffDetails';
import './app.css'
import Routes from './config/router';
import AreaDetails from './modules/Area/templates/AreaDetails';
import DispatchConfigDetails from './modules/DispatchConfig/templates/DispatchConfigDetails'
class App extends Component {


	render() {
		return (
			<div>
				<OrderDetails />
				<UserDetails />
				<BalanceDetails />
				<ReportDetails />
				<Routes />
				<Message />
				<RestaurantDetails />
				<GiftCardDetails />
				<PrinterDetails />
				<TariffDetails />
				<AreaDetails />
				<DispatchConfigDetails />
			</div>
		);
	}
}

export default connect()(App);
